import React from 'react'
import './achievment.css'
const Achievment = () => {
  return (
    <div className='mt-4'>
    <div className='achievment'>
      <p >Achievements</p>
      <h1 className='gradient__text'>A Journey Through Our Events and Workshops</h1>
    </div>
    <div className="achievment-sec2">
        <p>We believe in fostering growth and innovation by connecting blockchain enthusiasts and Web3 pioneers. Our initiatives emphasize hands-on learning, collaborative projects and providing opportunities for individuals to contribute to real-world decentralized applications (DApps). Join us in shaping the future of blockchain in Bhopal.</p>
    </div>
    </div>
  )
}

export default Achievment
